import { Bars } from 'react-loader-spinner';
import FullTableLayout from './FullTableLayout';
import OrdersMonitorTable from '../sales-management/OrdersMonitorTable';
import { useOrders } from '../../features/orders/useOrders.js';
import { FULL_TABLE_PARENTS } from './routes';

/**
 * Orders Monitor on its own page — same table, same tabs and filters, just
 * without the KPI strip and the two charts above it eating the viewport.
 */
const OrdersMonitorFull = () => {
  const { data: orders = [], isLoading, error, refetch } = useOrders();

  return (
    <FullTableLayout
      backTo={FULL_TABLE_PARENTS.orderMonitor}
      backLabel="Order Monitor"
    >
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: 320 }}
        >
          <Bars height="50" width="50" color="#3874ff" ariaLabel="loading" />
        </div>
      ) : (
        <>
          {error && (
            <div className="text-danger fs-10 mb-2">{String(error)}</div>
          )}
          <OrdersMonitorTable orders={orders} onRefresh={refetch} fullPage />
        </>
      )}
    </FullTableLayout>
  );
};

export default OrdersMonitorFull;
